import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine15 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 5.37211 5.37293 0 12 0C18.6279 0 24 5.37211 24 12C24 18.6279 18.6279 24 12 24C5.37293 24 0 18.6279 0 12Z",
				fill: "#A50034"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M6.85327 18.3447V8.35219C6.07903 8.96441 4.85454 9.55859 4.00814 9.93668L3.14371 7.99215C4.47644 7.43404 6.07903 6.58768 7.33886 5.63345H9.55407V18.3447H6.85327ZM15.1331 18.6506C13.656 18.6506 12.5217 18.3266 11.5498 17.7325L12.5758 15.7519C13.2779 16.2382 13.9988 16.5621 14.9887 16.5621C15.9787 16.5621 17.2212 15.968 17.2212 14.4737C17.2212 13.5555 16.6094 12.295 14.2686 12.2593C13.5485 12.2593 12.7021 12.2413 12.2879 12.2413L12.7923 5.63345H19.4718V7.75801H14.8985L14.7189 10.1708C14.7911 10.1708 14.9527 10.1885 15.0789 10.1885C18.554 10.3508 19.9581 12.313 19.9581 14.2215C19.9581 16.6523 18.0316 18.6506 15.1331 18.6506Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLine15);
export { ForwardRef as ReactComponent };
